import React, {Component} from 'react'

import breakdown from '../../assets/breakdown.png'
import './styles.css'

class About extends Component {
  render() {
    return (
      <div className="about">
        <div className="about-section">
          <div className="about-header">
            About Carbotax
          </div>
          <div className="about-text">
            <p>
              CarboTax is a web-based application that allows people to quickly understand how their climate impact compares to an easy-to-grasp benchmark – "the average American."
            </p>
            <p>
              Its goal is to educate people about their personal climate impacts.
            </p>
          </div>
        </div> 
        <div className="about-section">
          <div className="about-header">
            About Kensho
          </div>
          <div className="about-text">
            <p>
              Kensho Technologies is the leading provider of next-generation analytics systems to the global financial industry. 
              Kensho is pioneering scalable analytics and machine intelligence systems - and deploying them across the most
              critical government and commercial institutions in the world to solve some of the hardest analytical problems of our time.
            </p>
          </div>
        </div> 
        <div className="about-section">
          <div className="about-header">
            How does the CarboTax calculator work?
          </div>
          <div className="about-text">
            <p>
              The baseline climate impact used by CarboTax for the average American is 10.0 tonnes
              CO2e, which is derived through hundreds of calculations organized into 7 main
              categories -- Electricity, Heating, Transportation, Travel (air, boat, and hotel),
              Food/Beverages, Consumer Goods, and Waste &amp; Water. There are 20 main questions
              (several of which are divided into sub-questions), and each question modifies one or
              more line item through a simple multiplier. The line items are tabulated upon the
              completion of each question to create an updated footprint number.
            </p>
            <p>
              A top dashboard compares the user's impact for all greenhouse gases in carbon dioxide
              equivalent (CO2e) tonnes with the average baseline. As each question is answered,
              calculations are performed in the browser, instantly modifying the display. The
              background of the screen shifts colors accordingly -- the lower the individual's carbon
              impact the "cooler" or more blue. The higher the impact, the "hotter" or more red. The
              national average is represented as violet. With this approach, the user is able to quickly
              discover their climate impact by answering a series of intuitive questions.
            </p>
          </div>
        </div> 
        <div className="about-section">
          <div className="about-header">
            How is CarboTax different from other calculators?
          </div>
          <div className="about-text">
            <p>
              CarboTax utilize a split-attribution model in which the responsibility for the CO2e
              associated with a given product is shared between the companies that produced it and
              the consumer who purchased it, while emissions created from ongoing usage of the
              product are attributed entirely to the consumer. Using the logical argument that the
              producer is compensated according to fair market value for a given product, the two
              would split the carbon embedded in a given product 50/50.
            </p>
            <p>
              The approach used in many other calculators is a flat per capita attribution, which
              essentially divides the total emissions of a country by the number of people living in that
              country. For the U.S. (based on 2014 data) that would be approximately 26 tonnes
              CO2e per year per person. This is problematic as it puts the entire carbon burden onto
              the individual, and does not attribute any CO2e to the companies that manufacture the
              products or the commercial and public entities that purchase approximately half of total
              product inventories.
            </p>
          </div>
        </div> 
        <div className="about-section">
          <div className="about-header">
            How does split-attribution work?
          </div>
          <div className="about-text">
            <p>
              Before a product (say an iPhone) makes it into the consumer&#39;s hands, the manufacturer
              (Apple) needs to purchase an array of &quot;intermediate goods&quot; which are used in the
              manufacturing of the end products it sells to consumers (called &quot;value-added goods&quot;).
              So Apple is also acting as consumer and would thus need to split carbon 50/50 with its
              own supply chain. The 50% Apple is responsible for would then be combined with the
              added energy (and carbon) required to create the iPhone, which is then split 50/50 with
              the end-user. Here&#39;s a simple way to approximate this 2-tiered attribution model and how
              much the end consumer is ultimately responsible for:
            </p>
            <p>
              Approximately 43.2% of industrial output in the U.S. is made up of &quot;value added&quot; goods
              and 56.8% is used to make &quot;intermediate goods.&quot; So embedded CO2e for a given end
              product adds together all of the value-added carbon plus half of the intermediate carbon
              (43.2% + 28.4% = 71.6%). Thus the consumer&#39;s responsibility is half of these combined
              CO2e emissions -- 35.8%. This of course is an estimate. Various industrial sectors
              would have different splits with their supply chains, but it serves as a good proxy value in
              estimating consumer responsibility for industrial CO2e emissions.
            </p>
            <p>
              Take for example an automobile... 35.8% of emissions produced in the manufacturing of
              a shiny new car is attributed to the consumer, who will then be responsible for 100% of
              the emissions produced form burning gasoline after they drive their new car off the lot.
              Similarly, a homebuyer would take on 35.8% of the embedded carbon associated with
              the materials and energy used in construction, plus the energy they use in the house
              ongoing.
            </p>
            <p>
              Commercial and public entities can also act as consumers. Approximately 50% of all
              construction in the United States is for commercial and public buildings. Residential
              construction is 40%, and industrial construction is another 10%. Apportioning the total
              responsibility of 35.8% with a 40/50/10 split yields this ratio -- 14.3% residential, 17.9%
              commercial, and 3.6% manufacturing (which is added back into industrial impacts for a
              grand total of 67.8% for industrial emissions).
            </p>
            <p>
              This 40/50/10 split works out as a good approximation for carbon attribution for durable
              goods.This ratio does not apply to other industrial outputs like food and fuel. For fuel, the
              consumer is responsible for 100% of the combustion of the fuels they purchase (gas,
              electricity, oil) plus 50% of the carbon emitted in the extraction and production of those
              fuels. Similarly, food can be thought of as &quot;human fuel&quot; so we attribute 0% to commercial
              entities as all food products end up directly consumed by individuals, though food
              wasted by grocery stores is attributed to commercial sector. For livestock production, the
              only intermediate input is feed, which as above is split 50/50 with the consumer. For
              agriculture, the only intermediate inputs are pesticides and fertilizers, which are also split
              50/50 with the consumer.
            </p>
          </div>
        </div> 
        <div className="about-section">
          <div className="about-header">
            How did you arrive at 10 tonnes CO2 for the average American impact?
          </div>
          <div className="about-text">
            <p>
              Using the split-attribution model a baseline profile for the “Average American” can be
              derived from data published by the U.S. Environmental Protection Agency along with
              secondary sources to break apart attribution between various subsectors and consumer
              types. The CO2e Attribution Summary (see below) lists out sources of emissions in CO2
              equivalents for all gases -- CO2, CH4, N2O, and Fluorinated gases -- by sector. Using
              EIA survey data, for example, we can determine the exact percentage of electricity used
              by residential consumers (versus commercial and industrial consumers). From this list,
              we derive split ratios for Individuals, Commercial/Public Institutions, and Industry in our 7
              categories. Adding together impacts under each section, we find that Individuals are
              responsible for approximately 2/5 of total U.S. CO2e emissions (2914 MMT) with
              commercial, industrial and government entities responsible for remaining emissions
              (4518 MMT) for the reference year 2014 using our split-attribution model.
            </p>
            <p>
              The CarboTax model incorporates several impacts not previously accounted for: (1) net
              CO2 from industrial imports; (2) net CO2 from imported deforestation (Palm Oil); (3) net
              CO2 from beef imports/exports; (4) net CO2e reduction from farm exports; (5)
              unaccounted methane from hydraulic fracturing; (6) net CO2 from power used to deliver
              water; and (7) climatic forcing from aviation emissions above a 10,000 foot elevation.
              Lastly (8), carbon sequestration from U.S. domestic land use (LULUCF) is subtracted
              (discounted to 686 MMT). Dividing by 265 million people (adults + teens) we arrive at a
              total average impact of 10.0 tonnes CO2e emissions per person for the &quot;Average
              American&quot; in the reference year 2014.
            </p>
            <p className="about-img-container">
              <img className="about-img" alt="co2 breakdown chart" src={breakdown} />
            </p>
            <p>
              Ground Transportation (automobiles and light-duty trucks, motorcycles, bus, and rail) is
              the single largest individual impact category representing 3.2 tonnes (28.9%) of an
              individual&#39;s total CO2e emissions, inclusive of the embedded emissions from the
              extraction and production of petroleum. Home energy use -- Electricity and Heating --
              makes up another 3.5 tonnes (15.2% and 16.6% respectively). Travel, which includes air
              travel, boat travel and hotels, is broken out as a separate energy category representing
              0.7 tonnes (6.1%). Food and Beverage consumption represents 2.4 tonnes of emissions
              (21.8%), with other Consumer Goods representing 0.9 tonnes of impact (8.1%). Lastly
              Waste and Water (including power for water treatment and supply) represents 0.4
              tonnes (3.4%).
            </p>
          </div>
        </div> 
        <div className="about-section">
          <div className="about-header">
            How do questions modify the baseline average?
          </div>
          <div className="about-text">
            <p>
              CarboTax establishes a set of factors to modify the above baseline, creating the first-
              ever carbon calculator that incorporates personal attribution for all greenhouse gases
              (not just CO2) as well as imported/exported CO2e emissions, power for water, and many
              other significant factors not usually considered in an individual&#39;s carbon footprint. A
              series of questions act as modifiers to the baseline model, enabling the user to learn
              about their impacts and see in real-time how their total footprint compares to the
              &quot;Average American.&quot;
            </p>
            <p>
              Hundreds of calculations were required to create modifier values for each question,
              which can modify one or more of the baseline values for the Average American. There
              are some modifiers (e.g. State of Residence) over which the individual has very little
              control but which significantly impacts their total CO2e profile. For example, grid
              efficiency varies greatly by State, so the zip code modifies the user&#39;s electricity baseline
              based on the grid efficiency of their State of residence as well as average heating for
              that State. Other modifiers will depend on the user&#39;s lifestyle (e.g. Air Travel). The
              average American emits 0.425 tonnes CO2 for air travel per year -- the equivalent of one
              round-trip flight from Los Angeles to Dallas. Some people fly much more, and this added
              CO2 will be accounted through a more detailed questionnaire about travel in the past 12
              months.
            </p>
          </div>
        </div> 
      </div>
    )
  }
}

export default About



// WEBPACK FOOTER //
// ./src/apps/About/index.js